import { render, staticRenderFns } from "./module-laundry.vue?vue&type=template&id=7c1f692e&"
import script from "./module-laundry.vue?vue&type=script&lang=js&"
export * from "./module-laundry.vue?vue&type=script&lang=js&"
import style0 from "./module-laundry.vue?vue&type=style&index=0&id=7c1f692e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports